
import { SELECTED_REQUESTERID } from "./type"

const superAdmin = process.env.REACT_APP_ISSUPERADMIN
var superAdminList = JSON.parse(superAdmin);
const reqId = localStorage.getItem('requesterId')
const initialState = {
    requesterId : reqId || undefined }
const selectedretailerReqesterReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case SELECTED_REQUESTERID:
            return {
               ...state,
               requesterId:superAdminList.includes(action.payload?.id) ? undefined : action.payload?.reqId
            }
        default:
            return state
    }
}

export default selectedretailerReqesterReducer